import * as React from 'react';

import { ISpecialistCatalogListingSchema } from '../../repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';
import {
  AboutRealtorMobile,
  AdditionalInfoMobile,
  GeneralInfoMobile,
  PhotoMobile,
} from '../../components/AboutRealtorMobile';
import { OneStarRate } from '../../components/OneStarRate';
import { useSelector } from 'react-redux';
import { selectChatsStatistics } from '../../selectors/selectChatsStatistics';
import { selectCurrentRealtor } from '../../selectors/selectCurrentRealtor';
import { Responsive } from '@cian/ui-kit';
import { ChatStatisticsMobileContainer } from '../ChatStatisticsMobileContainer';
import { getRateType } from '../../utils/getRateType';
import { selectAgent } from '../../selectors/selectAgent';
import { IAgent } from '../../models/agent';

export const AboutRealtorMobileContainer = () => {
  /** полагаем, что значения здесь не могут быть пустыми */
  const chatsStatistics = useSelector(selectChatsStatistics);
  const { age, name, avatarUrl, companyName, regionsNames, experience, skills, hasFairplay } = useSelector(
    selectAgent,
  ) as IAgent;
  const { reviewsRate } = useSelector(selectCurrentRealtor) as ISpecialistCatalogListingSchema;

  const responseRateType = chatsStatistics?.responseRate ? getRateType(chatsStatistics.responseRate) : null;

  return (
    <AboutRealtorMobile
      responseRateType={responseRateType}
      generalInfo={<GeneralInfoMobile name={name} companyName={companyName} age={age} />}
      chatStatistics={<ChatStatisticsMobileContainer />}
      photo={
        <>
          <Responsive phone>
            <PhotoMobile size={70} url={avatarUrl} hasFairplay={hasFairplay} />
          </Responsive>
          <Responsive tablet>
            <PhotoMobile size={100} url={avatarUrl} hasFairplay={hasFairplay} />
          </Responsive>
        </>
      }
      rate={<OneStarRate reviewsRate={reviewsRate || 0} size={'M'} uniqueKey={'AboutRealtorMobileContainer'} />}
      additionalInfo={<AdditionalInfoMobile experience={experience} regionsNames={regionsNames} skills={skills} />}
    />
  );
};

AboutRealtorMobileContainer.displayName = 'AboutRealtorMobileContainer';
